import _ from 'underscore';
import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';
import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Formatters, Messages } from '../../codegen/Localize';
import { simpleActionErrorMsg, simpleActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../ts/L10n/L10n';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';
import { Set } from '../../ts/models/Set';
import { FlowTasksPriorityDialogContent, FlowTasksPriorityDialogContentProps, FlowTasksPriorityDialogState } from '../components/FlowTasksPriorityDialogContent';
import { RunFlowTasks } from '../resources/RunFlowTasks';

export namespace ChangeRunFlowTasksPriorityAction {
  export function dialog(runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    let dialogMessage: string;
    if(runFlowTaskInfos.size() === 1) {
      const task = runFlowTaskInfos.first();
      dialogMessage = Messages.runFlowTasksSetPriorityPrompt({
        FLOW_NAME: L10n.elideIfLong(task.flow.name)
      });
    } else {
      dialogMessage = Messages.runFlowTasksSetPriorityMultiplePrompt({
        ITEM_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()),
      });
    }

    const priority = getPriority(runFlowTaskInfos);

    const dialogInstance = openReactActionDialog<FlowTasksPriorityDialogContentProps, FlowTasksPriorityDialogState, IResult>({
      title: Messages.tasksSetPriority(),
      bodyComponent: FlowTasksPriorityDialogContent,
      initialBodyProps: {
        dialogMessage,
        start: priority,
      },
      initialDialogState: {
        value: priority,
      },
      dialogWidth: TabDialogWidth.width375px,
      dismissDialogOnActionFailed: true,
      actionName: Messages.tasksSetPriorityConfirm({
        ITEM_COUNT: runFlowTaskInfos.size(),
        ITEM_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()),
      }),
      action: (_, state) => RunFlowTasks.setPriority(runFlowTaskInfos.keys(), state.value)
    });

    dialogInstance.result.then((result: IResult) => {
      ContentActionNotification.displaySingleToastForResult({
        items: runFlowTaskInfos,
        errors: result.errors,
        successMsg: simpleActionSuccessMsg(Messages.runFlowTasksSetPrioritySuccess),
        errorMsg: simpleActionErrorMsg(Messages.runFlowTasksSetPriorityError),
      });
    });

    return Promise.resolve(dialogInstance.result);
  }

  function getPriority(runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    return Math.min(..._.map(runFlowTaskInfos.toArray(), (tasks: RunFlowTaskInfo) => tasks.priority));
  }
}
